import api from './api';

export const getRules = async (params = {}) => {
  const response = await api.get('/rules/', { params });
  return response.data;
};

export const getRule = async (id) => {
  const response = await api.get(`/rules/${id}`);
  return response.data;
};

export const createRule = async (ruleData) => {
  const response = await api.post('/rules/', ruleData);
  return response.data;
};

export const updateRule = async (id, ruleData) => {
  const response = await api.put(`/rules/${id}`, ruleData);
  return response.data;
};

export const deleteRule = async (id) => {
  const response = await api.delete(`/rules/${id}`);
  return response.data;
};